// Header menu
export const selectedStoreId = 'selectedStore';
